export enum ChangePasswordStep {
  ENTER_NEW_PASSWORD = 'ENTER_NEW_PASSWORD',
  SUCCESSFULLY_CHANGED = 'SUCCESSFULLY_CHANGED',
}

export enum ChangePasswordField {
  existingPassword = 'existingPassword',
  newPassword = 'newPassword',
  confirmNewPassword = 'confirmNewPassword',
}

export interface ChangePasswordForm {
  [ChangePasswordField.existingPassword]: string;
  [ChangePasswordField.newPassword]: string;
  [ChangePasswordField.confirmNewPassword]: string;
}
